<template>
    <v-main>
        <v-container fill-height fluid>
            <v-scroll-x-reverse-transition mode="out-in">
                <v-form @submit.prevent="send_email" v-if="!success" style="width: 100%">
                    <v-row justify="center">
                        <v-col align="center" cols="12">
                            <v-icon v-if="error_code == 200" style="font-size: 200px; opacity: 0.3" class="pb-5">mail_outline</v-icon>
                            <div v-else>
                                <h1 style="font-size: 80px; opacity: 0.3">{{ error_code }}</h1>
                                <v-icon style="font-size: 200px; opacity: 0.3" class="pb-16">sentiment_very_dissatisfied</v-icon>
                            </div>
                        </v-col>
                        <v-col style="position: relative"  align="center" cols="12" class="pt-0 pb-5">
                            <v-fade-transition>
                                <v-btn
                                  v-if="wrong_email"
                                  style="width: 330px; position:absolute; top: 0px; transform: translateX(-50%) translateY(-110%)"
                                  rounded
                                  color="error"
                                  outlined
                                  type="submit"
                                  >
                                      <v-icon left>error</v-icon>
                                      email not found
                                </v-btn>
                            </v-fade-transition>
                        </v-col>
                        <v-col align="center" cols="12" class="pt-0 pb-0">
                            <v-text-field
                              v-model="email"
                              @input="wrong_email = false"
                              filled
                              dense
                              rounded
                              placeholder="user@example.com"
                              class="centered-input"
                              style="width: 330px"
                              />
                        </v-col>
                        <v-col align="center" cols="12" class="pt-0">
                            <v-btn
                              rounded
                              style="width: 330px"
                              :disabled="!valid_email || wrong_email"
                              color="primary"
                              type="submit"
                              :loading="loading"
                              >
                                <v-icon left>send</v-icon> Send personal link
                            </v-btn>
                        </v-col>
                    </v-row>
                    </v-form>
                <template v-else>
                    <v-row justify="center">
                        <v-col align="center" cols="12">
                            <v-icon style="font-size: 200px; opacity: 0.3">done</v-icon>
                        </v-col>
                        <v-col align="center" cols="12" class="pt-5 pb-0">
                            <span style="opacity: .5">Link sent to</span> <span  style="opacity: .9">{{ email }}</span>
                        </v-col>
                    </v-row>
                </template>
            </v-scroll-x-reverse-transition>
        </v-container>
    </v-main>
</template>

<style type="scss">
.centered-input input {
  text-align: center
}
</style>

<script>

import axios from 'axios';

export default {
    name: 'SendLink',
    props: {
        error_code: {
            type: Number,
            default: 200
        }
    },
    data () {
        return {
            email: '',
            success: false,
            wrong_email: false,
            loading: false
        }
    },
    methods: {
        async send_email () {
            this.loading = true;

            try {
                await axios.post(
                    this.$store.getters['api/api_base'] + 'send_link',
                    {
                        email: this.email.trim()
                    }
                );
                this.success = true;
            } catch {
                this.success = false;
                this.wrong_email = true;
            }
            this.loading = false;
        }
    },
    computed: {
        valid_email () {
            const pattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
            return pattern.test(this.email.trim());
        }
    },
    created () {
        var type = window.localStorage.getItem('type');
        var hash = window.localStorage.getItem('hash');
        if (type && hash) {
            this.$router.push({
                path: `/${type}/${hash}`
            })
        }
    }
}
</script>
